import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ResponseDialogComponent, ResponseDialogMode } from '../components/response-dialog/response-dialog.component';

@Injectable({ providedIn: 'root' })
export class ResponseBlockedModalService {
  constructor(private modalService: NgbModal) {}

  open(mode: ResponseDialogMode, projectId: string | null = null, options: { isTrial: boolean; planLabel: string } | null = null): void {
    const ref = this.modalService.open(ResponseDialogComponent, {
      centered: true,
      windowClass: 'project-blocked-modal-dialog',
      backdropClass: 'blur-backdrop',
    });
    ref.componentInstance.mode = mode;
    if (options) {
      ref.componentInstance.isTrial = options.isTrial;
      ref.componentInstance.planLabel = options.planLabel;
    }
    ref.componentInstance.projectId = projectId;
  }
}
